"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumNetNamingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const AltiumLabelTypeNameUtil_1 = require("./AltiumLabelTypeNameUtil");
class AltiumNetNamingRule {
    constructor(config, namingStrategy) {
        this.config = config;
        this.namingStrategy = namingStrategy;
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    dereferenceLabelName(name) {
        try {
            const result = AltiumLabelTypeNameUtil_1.AltiumLabelTypeNameUtil.parseLabelTypeName(name);
            return result.name;
        }
        catch {
            return name;
        }
    }
}
exports.AltiumNetNamingRule = AltiumNetNamingRule;
//# sourceMappingURL=AltiumNetNamingRule.js.map